// Custom variant meta
document.addEventListener('DOMContentLoaded', function () {
  var customVariantData = document.querySelector('#custom-variant-data');
  if (!customVariantData) return;
  
  var variantTitle = document.querySelector('.custom-variant_title');
  var variantDescription = document.querySelector('.custom-variant_description');
  var productVariant = document.querySelector('[data-variant-input]');
  if (!productVariant) return;

  productVariant.addEventListener('change', function(e) {
    var match = customVariantData.querySelector('[data-option="' + e.target.value + '"]');
    if (!match) return;

    variantTitle.textContent = match.dataset.title || '';
    variantDescription.textContent = match.textContent || '';
  })
});